import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { getCurrentEnterpriseIntegrationName } from '@mews-commander/legacy-entities/src/selectors/enterpriseIntegrations';

interface ViaIntegrationProps {
    integrationName?: string | null;
}

const ViaIntegration = ({ integrationName }: ViaIntegrationProps) => (
    <LocalizedText textKey={TextKey.ViaName} substitutes={{ name: integrationName || '' }} firstLowerCase />
);

export default connect<ViaIntegrationProps, {}, { integrationId: string }, ApplicationState>(
    createStructuredSelector({
        integrationName: getCurrentEnterpriseIntegrationName,
    })
)(ViaIntegration);
